import { gql } from '@apollo/client';

const listPartnersQuery = gql`
  query ListPartnersQuery($partnershipType: OdProtosPartnershipData_PartnershipType!) {
    partnership {
      listPartners(input: { partnershipType: $partnershipType }) {
        partners {
          identifier
          displayName
        }
      }
    }
  }
`;

export default listPartnersQuery;
